// OutputWall.jsx - Social Proof (without fake testimonials)
import React from 'react';
import './OutputWall.css';
import landingData from '../data/landingData.json';

const OutputWall = () => {
  const { outputs } = landingData;
  return (
    <section className="output-section">
      <h2 className="section-title">Made with URO</h2>

      <div className="output-grid">
        {outputs.map((src, index) => (
          <div key={index} className="output-item">
            <img src={src} alt={`Output ${index + 1}`} />
          </div>
        ))}
      </div>

      <p className="output-more">and 1+ Million More</p>

      <p className="founder-note">
        Built by a small team. Shipping weekly.
      </p>
    </section>
  );
};

export default OutputWall;
